var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _path, _circle, _circle2, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHexdetailloader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 443,
    height: 756,
    viewBox: "0 0 443 756",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 443,
    height: 756,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 322,
    width: 390,
    height: 198,
    fill: "#CBD5E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 291,
    width: 221,
    height: 13,
    fill: "#CBD5E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 356,
    width: 89,
    height: 13,
    fill: "black",
    fillOpacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 538,
    width: 48,
    height: 13,
    fill: "#CBD5E1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 568,
    width: 48,
    height: 13,
    fill: "#CBD5E1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 598,
    width: 48,
    height: 13,
    fill: "#CBD5E1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 628,
    width: 48,
    height: 13,
    fill: "#CBD5E1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 658,
    width: 48,
    height: 13,
    fill: "#CBD5E1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 688,
    width: 48,
    height: 13,
    fill: "#CBD5E1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 718,
    width: 48,
    height: 13,
    fill: "#CBD5E1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 538,
    width: 332,
    height: 13,
    fill: "#CBD5E1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 568,
    width: 332,
    height: 13,
    fill: "#CBD5E1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 598,
    width: 332,
    height: 13,
    fill: "#CBD5E1"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 628,
    width: 332,
    height: 13,
    fill: "#CBD5E1"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 658,
    width: 332,
    height: 13,
    fill: "#CBD5E1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 688,
    width: 332,
    height: 13,
    fill: "#CBD5E1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 718,
    width: 332,
    height: 13,
    fill: "#CBD5E1"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 446,
    width: 89,
    height: 13,
    fill: "black",
    fillOpacity: 0.1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 384,
    width: 350,
    height: 13,
    fill: "black",
    fillOpacity: 0.1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 474,
    width: 350,
    height: 13,
    fill: "black",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 33L319.794 89.75V203.25L221.5 260L123.206 203.25V89.75L221.5 33Z",
    fill: "#CBD5E1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 167.5,
    r: 17.5,
    fill: "#CBD5E1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.5,
    cy: 167.5,
    r: 17.5,
    fill: "#CBD5E1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 405.5,
    cy: 30.5,
    r: 11.5,
    fill: "#CBD5E1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.5,
    cy: 30.5,
    r: 11.5,
    fill: "#CBD5E1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexdetailloader);
export default __webpack_public_path__ + "static/media/hexdetailloader.fe03dc2105fe2258c58e37cfc9405747.svg";
export { ForwardRef as ReactComponent };